import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AccountService } from 'src/app/services/account.service';
import { FormResponse } from 'src/models/form-response';
import { AlertBoxType } from '../base/alert-box/alertboxtype';
import { FormComponent } from '../base/form/form.component';
import { SimpleModalService } from 'ngx-simple-modal';
import { TermsAndConditionsComponent } from '../terms-and-conditions/terms-and-conditions.component';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent extends FormComponent implements OnInit {

  // passwort: at least length 8, containing at least one lowercase letter, and at least one uppercase letter and at least one number
  public signUpForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required, this.validatorPatternPassword]),
    confirmPassword: new FormControl('', [Validators.required, this.matchValues('password')]),
    captcha: new FormControl(''),
    agree: new FormControl('', [Validators.required])
  });

  public formResponse: FormResponse;

  public alertBoxTypes = AlertBoxType;

  public submitDisabled = false;

  constructor(private accountService: AccountService, private simpleModalService: SimpleModalService, private changeDetector: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {

    this.password.valueChanges.subscribe(() => {
      this.confirmPassword.updateValueAndValidity();
    });
  }

  get email() { return this.signUpForm.get('email'); }

  get password() { return this.signUpForm.get('password'); }
  get confirmPassword() { return this.signUpForm.get('confirmPassword'); }

  get captcha() { return this.signUpForm.get('captcha'); }

  get agree() { return this.signUpForm.get('agree'); }

  public showTermsAndConditions() {
      this.simpleModalService.addModal(TermsAndConditionsComponent, {
            title: 'Confirm title',
            message: 'Confirm message'
          })
          .subscribe((isConfirmed)=>{
          });

  }

  public submit() {

    if (this.signUpForm.valid) {
      this.submitDisabled = true;
      this.accountService.signup(this.email.value, this.password.value, this.captcha.value).subscribe((result: FormResponse) => {

        this.formResponse = result;

        if (this.formResponse.result === true) {
          this.signUpForm.reset();
        }

        this.submitDisabled = false;

        this.changeDetector.detectChanges();
      });
    } else {
      this.email.markAsDirty();
      this.password.markAsDirty();
      this.confirmPassword.markAsDirty();
      this.agree.markAsDirty();
  }

  }

  public hasErrors() {
    return this.formResponse !== undefined && this.formResponse.errors !== undefined && this.formResponse.errors.length > 0;
  }

}
